<template>
  <div class="main_Container">
    <section class="p-4">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <h3 class="card-header-title">أضافة درس</h3>
          </div>
          <div class="card-body">
            <form id="addLesson" @submit.prevent="addNewLesson">
              <div class="card-body__form">
                <div class="row">
                  <!---------------->
                  <!-- Right Side -->
                  <div class="col-md-7 col-12">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group">
                          <label for="lessonTitle">العنوان</label>
                          <input
                            type="text"
                            class="form-control mt-2"
                            id="lessonTitle"
                            aria-describedby="addressHelp"
                            placeholder="العنوان"
                            v-model="lesson.title"
                            required
                          />
                        </div>
                      </div>

                      <div class="col-12">
                        <div class="adding">
                          <div class="adding__head">
                            <label>محتوى للدرس</label>
                            <div class="dropdown">
                              <button
                                class="btn dropdown-toggle btn-primary"
                                type="button"
                                id="dropdownMenuButton1"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i class="fa fa-plus ms-1"></i>

                                أضف محتوى
                              </button>
                              <ul
                                class="dropdown-menu"
                                aria-labelledby="dropdownMenuButton1"
                              >
                                <li>
                                  <button
                                    type="button"
                                    data-bs-toggle="modal"
                                    data-bs-target="#addLessonFile"
                                    class="dropdown-item"
                                  >
                                    <i class="fa fa-plus ms-1"></i>
                                    أضف ملف
                                  </button>
                                </li>
                                <li>
                                  <router-link
                                    class="dropdown-item"
                                    to="/admin/lessons/add_video"
                                    @click="saveLesson"
                                  >
                                    <i class="fa fa-plus ms-1"></i>
                                    أضف فيديو
                                  </router-link>
                                </li>
                                <li>
                                  <router-link
                                    class="dropdown-item"
                                    to="/admin/lessons/add_exam"
                                    @click="saveLesson"
                                  >
                                    <i class="fa fa-plus ms-1"></i>
                                    أضف امتحان
                                  </router-link>
                                </li>
                              </ul>
                            </div>

                            <!-- Add File Modal -->
                            <div
                              class="modal fade"
                              id="addLessonFile"
                              data-bs-backdrop="static"
                              data-bs-keyboard="false"
                              tabindex="-1"
                              aria-labelledby="addLessonFileLabel"
                              aria-hidden="true"
                            >
                              <div class="modal-dialog modal-dialog-centered">
                                <div class="modal-content">
                                  <div class="modal-header">
                                    <h5 class="modal-title">أضافة ملف</h5>
                                    <button
                                      type="button"
                                      class="btn-close"
                                      data-bs-dismiss="modal"
                                      aria-label="Close"
                                      @click="this.clearData()"
                                    ></button>
                                  </div>
                                  <div class="modal-body">
                                    <form
                                      id="addFile"
                                      @submit.prevent="addNewFile($event)"
                                    >
                                      <div class="row">
                                        <div class="col-12">
                                          <div class="form-group">
                                            <label for="lessonFileName"
                                              >اسم الملف</label
                                            >
                                            <input
                                              type="text"
                                              class="form-control"
                                              id="lessonFileName"
                                              placeholder="اسم الملف"
                                              v-model="selectedFileLesson.title"
                                              required
                                            />
                                          </div>
                                        </div>
                                        <div class="col-sm-6">
                                          <div class="form-group files">
                                            <label for="lessonFile"
                                              >أضف الملف</label
                                            >
                                            <!-- Custom Input File -->
                                            <div
                                              class="dragDrop small"
                                              @dragover="onDropOver($event)"
                                              @dragleave="onDropLeave($event)"
                                            >
                                              <div
                                                v-if="this.file == null"
                                                class="dragDrop__input"
                                              >
                                                <div
                                                  class="dragDrop__input__icon"
                                                >
                                                  <i
                                                    class="fa fa-upload icon"
                                                    aria-hidden="true"
                                                  ></i>
                                                </div>
                                              </div>
                                              <div
                                                v-else
                                                class="dragDrop__file"
                                              >
                                                <div
                                                  class="dragDrop__file__icon"
                                                >
                                                  <i
                                                    class="fa fa-file icon"
                                                    aria-hidden="true"
                                                  ></i>
                                                </div>
                                                <div
                                                  class="dragDrop__file__text"
                                                >
                                                  <span>{{
                                                    this.file.name
                                                  }}</span>
                                                </div>
                                              </div>
                                              <input
                                                type="file"
                                                id="chooseFiles"
                                                placeholder="أضف الملف"
                                                required
                                                @change="onFileSelect($event)"
                                                accept="application/pdf"
                                              />
                                            </div>
                                            <!-- Custom Input File -->
                                          </div>
                                        </div>
                                        <div class="col-sm-6">
                                          <div class="form-group">
                                            <label for="fileImage"
                                              >صورة الملف (اختيارى)</label
                                            >
                                            <UploadImages
                                              class="form-control mt-2"
                                              @changed="handlefileImages"
                                              id="questionImage"
                                              :max="1"
                                              maxError="يمكنك رفع صورة واحدة لكل سوال"
                                              fileError="لا يمكن رفع ملفات غير الصور"
                                            />
                                          </div>
                                        </div>

                                        <div class="col-12">
                                          <div
                                            class="
                                              buttons__container
                                              text-start
                                            "
                                          >
                                            <button
                                              type="submit"
                                              class="btn add w-100"
                                            >
                                              إضافة
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- Add File Modal -->
                          </div>

                          <div class="adding__content">
                            <!-- Show All Files -->
                            <div
                              class="table-responsive mt-4"
                              v-show="this.lesson.contents.length > 0"
                            >
                              <Transition name="scale" mode="out-in">
                                <table
                                  class="
                                    table
                                    sub_table
                                    styled-table
                                    subject-table
                                    table-striped
                                  "
                                >
                                  <thead>
                                    <tr>
                                      <th class="fit" scope="col">الرقم</th>
                                      <th scope="col">العنوان</th>
                                      <th style="width: 20%" scope="col">
                                        نوع الملف
                                      </th>
                                      <th scope="col">التحكم</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="(file, index) in this.lesson
                                        .contents"
                                      :key="index"
                                    >
                                      <th class="text-center" scope="row">
                                        {{ index + 1 }}
                                      </th>

                                      <td>{{ file.title }}</td>
                                      <td>{{ filterItems(file.type) }}</td>
                                      <td class="controls">
                                        <!-- If Edit File -->
                                        <div
                                          class="ms-2"
                                          style="display: inline-block"
                                          v-if="file.type == 1"
                                        >
                                          <button
                                            class="btn edit icon"
                                            data-bs-toggle="modal"
                                            data-bs-target="#EditLessonFile"
                                            type="button"
                                            @click="
                                              this.getSelectedFile(file.id)
                                            "
                                          >
                                            <i class="fas fa-edit"></i>
                                          </button>
                                          <!-- Edit File Modal -->
                                          <div
                                            class="modal fade"
                                            id="EditLessonFile"
                                            data-bs-backdrop="static"
                                            data-bs-keyboard="false"
                                            tabindex="-1"
                                            aria-labelledby="EditLessonFileLabel"
                                            aria-hidden="true"
                                          >
                                            <div
                                              class="
                                                modal-dialog
                                                modal-dialog-centered
                                              "
                                            >
                                              <div class="modal-content">
                                                <div class="modal-header">
                                                  <h5 class="modal-title">
                                                    تعديل الملف
                                                  </h5>
                                                  <button
                                                    type="button"
                                                    class="btn-close"
                                                    data-bs-dismiss="modal"
                                                    aria-label="Close"
                                                    @click="this.clearData()"
                                                  ></button>
                                                </div>
                                                <div class="modal-body">
                                                  <form
                                                    id="edit"
                                                    @submit.prevent="
                                                      updateSelectedFile($event)
                                                    "
                                                  >
                                                    <!-- Title -->
                                                    <div class="form-group">
                                                      <label
                                                        for="EditlessonFileName"
                                                        >اسم الملف</label
                                                      >
                                                      <input
                                                        type="text"
                                                        class="form-control"
                                                        id="EditlessonFileName"
                                                        placeholder="اسم الملف"
                                                        required
                                                        v-model="
                                                          selectedFileLesson.title
                                                        "
                                                      />
                                                    </div>
                                                    <div class="form-group">
                                                      <label for="fileImage"
                                                        >صورة الملف</label
                                                      >
                                                      <div class="row">
                                                        <div class="col-lg-6">
                                                          <UploadImages
                                                            class="
                                                              form-control
                                                              mt-2
                                                            "
                                                            @changed="
                                                              handlefileImages
                                                            "
                                                            id="questionImage"
                                                            :max="1"
                                                            maxError="يمكنك رفع صورة واحدة لكل سوال"
                                                            fileError="لا يمكن رفع ملفات غير الصور"
                                                          />
                                                        </div>

                                                        <div
                                                          class="
                                                            img-container
                                                            mt-2
                                                            col-lg-6
                                                          "
                                                          v-if="
                                                            selectedFileLesson.image_url
                                                          "
                                                        >
                                                          <img
                                                            :src="
                                                              selectedFileLesson.image_url
                                                            "
                                                            class="img-fluid"
                                                            alt="file image"
                                                          />
                                                        </div>
                                                        <div
                                                          class="
                                                            img__container
                                                            mt-2
                                                            col-lg-6
                                                          "
                                                          v-else
                                                        >
                                                          <span
                                                            >لا توجد صورة</span
                                                          >
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div
                                                      class="form-group files"
                                                    >
                                                      <label for="lessonFile"
                                                        >أضف الملف</label
                                                      >
                                                      <!-- Custom Input File -->
                                                      <div
                                                        class="dragDrop"
                                                        @dragover="
                                                          onDropOver($event)
                                                        "
                                                        @dragleave="
                                                          onDropLeave($event)
                                                        "
                                                      >
                                                        <div
                                                          v-if="
                                                            this.file == null
                                                          "
                                                          class="
                                                            dragDrop__input
                                                          "
                                                        >
                                                          <div
                                                            class="
                                                              dragDrop__input__icon
                                                            "
                                                          >
                                                            <i
                                                              class="
                                                                fa fa-upload
                                                                icon
                                                              "
                                                              aria-hidden="true"
                                                            ></i>
                                                          </div>
                                                        </div>
                                                        <div
                                                          v-else
                                                          class="dragDrop__file"
                                                        >
                                                          <div
                                                            class="
                                                              dragDrop__file__icon
                                                            "
                                                          >
                                                            <i
                                                              class="
                                                                fa fa-file
                                                                icon
                                                              "
                                                              aria-hidden="true"
                                                            ></i>
                                                          </div>
                                                          <div
                                                            class="
                                                              dragDrop__file__text
                                                            "
                                                          >
                                                            <span>{{
                                                              this.file.name
                                                            }}</span>
                                                          </div>
                                                        </div>
                                                        <input
                                                          type="file"
                                                          id="chooseFiles"
                                                          placeholder="أضف الملف"
                                                          @change="
                                                            onFileSelect($event)
                                                          "
                                                          accept="application/pdf"
                                                        />
                                                      </div>
                                                      <!-- Custom Input File -->
                                                    </div>

                                                    <div
                                                      class="
                                                        buttons__container
                                                        text-start
                                                      "
                                                    >
                                                      <button
                                                        type="submit"
                                                        class="btn add w-100"
                                                      >
                                                        تعديل
                                                      </button>
                                                    </div>
                                                  </form>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <!-- Edit File Modal -->

                                          <!-- Delete File -->
                                          <button
                                            class="btn delete icon"
                                            type="button"
                                            @click="
                                              this.deleteSeletedFile(file)
                                            "
                                          >
                                            <i class="fas fa-trash-alt"></i>
                                          </button>
                                        </div>
                                        <!-- If Edit Video -->
                                        <div
                                          style="display: inline-block"
                                          v-if="file.type == 2"
                                        >
                                          <router-link
                                            class="btn edit icon"
                                            :to="{
                                              name: 'AddLessonEditVideo',
                                              params: { index: file.id },
                                            }"
                                          >
                                            <i class="fas fa-edit"></i>
                                          </router-link>

                                          <!-- Delete File -->
                                          <button
                                            class="btn delete icon"
                                            type="button"
                                            @click="
                                              this.deleteSeletedVideo(file)
                                            "
                                          >
                                            <i class="fas fa-trash-alt"></i>
                                          </button>
                                        </div>
                                        <!-- If Edit Exam -->
                                        <div
                                          style="display: inline-block"
                                          v-if="file.type == 3"
                                        >
                                          <router-link
                                            class="btn edit icon"
                                            :to="{
                                              name: 'AddLessonEditExam',
                                              params: { index: file.id },
                                            }"
                                          >
                                            <i class="fas fa-edit"></i>
                                          </router-link>
                                          <!-- Delete File -->
                                          <button
                                            class="btn delete icon"
                                            type="button"
                                            @click="
                                              this.deleteSeletedExam(file)
                                            "
                                          >
                                            <i class="fas fa-trash-alt"></i>
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </Transition>
                            </div>
                            <div v-show="this.lesson.contents.length == 0">
                              <Transition name="scale" mode="out-in">
                                <div class="no-data">
                                  <i class="icon fas fa-exclamation-circle"></i>
                                  <p>قم بأضافة محتوى للدرس</p>
                                </div>
                              </Transition>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!---------------->
                  <!---------------->
                  <!-- Left Side -->
                  <div class="col-md-5">
                    <div class="form-group">
                      <label for="lessonPrice">السعر</label>
                      <input
                        type="number"
                        class="form-control mt-2"
                        id="lessonPrice"
                        min="0"
                        v-model="lesson.price"
                        placeholder="السعر"
                        required
                      />
                    </div>
                    <div class="form-group">
                      <label for="lessonStatus">حالة الدرس</label>
                      <select
                        class="form-select form-control mt-2"
                        aria-label="Default select "
                        v-model="lesson.status"
                      >
                        <option selected disabled value="">
                          اختار حالة الدرس
                        </option>
                        <option :value="0">حفظ داخل مسودة</option>
                        <option :value="1">نشر</option>
                      </select>
                    </div>
                  </div>
                  <!---------------->
                </div>
              </div>

              <div class="card-footer">
                <button
                  type="button"
                  @click="deleteLesson"
                  class="btn delete ms-2"
                >
                  خذف
                </button>
                <button
                  class="btn add"
                  data-bs-toggle="modal"
                  data-bs-target="#AddSelectedLesson"
                  type="button"
                >
                  التالى
                </button>
                <div
                  class="modal fade"
                  id="AddSelectedLesson"
                  data-bs-backdrop="static"
                  data-bs-keyboard="false"
                  tabindex="-1"
                  aria-labelledby="AddSelectedLessonLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title">معلومات الدرس</h5>
                        <button
                          type="button"
                          class="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                          @click="this.clearData()"
                        ></button>
                      </div>
                      <div class="modal-body">
                        <div class="form-group">
                          <label>صورة الدرس</label>

                          <UploadImages
                            class="form-control"
                            @changed="handleLessonImages"
                            :max="1"
                            maxError="يمكنك رفع صورة واحدة لكل درس"
                            fileError="لا يمكن رفع ملفات غير الصور"
                          />
                        </div>
                        <!-- Add Categories Select -->
                        <div class="categories__select">
                          <div
                            class="categories__select__data"
                            v-show="this.categories.length > 0"
                          >
                            <div class="row">
                              <div class="col-lg-6">
                                <div class="form-group">
                                  <label>التصنيف</label>
                                  <select
                                    class="form-select form-control mt-2"
                                    aria-label="Default select "
                                    id="mainCategory"
                                    @change="onSelectMainCategory($event)"
                                  >
                                    <option selected disabled :value="0">
                                      اختار التصنيف
                                    </option>
                                    <option
                                      v-for="category in this.Maincategories"
                                      :key="category.category_id"
                                      :value="category.title"
                                    >
                                      {{ category.title }}
                                    </option>
                                  </select>
                                </div>
                              </div>
                              <div class="col-lg-6">
                                <Transition name="scale" mode="out-in">
                                  <div
                                    class="form-group"
                                    v-if="this.subSelect.length > 0"
                                  >
                                    <label>تصنيف فرعى</label>
                                    <select
                                      class="form-select form-control mt-2"
                                      aria-label="Default select "
                                      id="subCategory"
                                      required
                                      @change="onSelectSubCategory($event)"
                                    >
                                      <option selected disabled value="">
                                        اختار التصنيف
                                      </option>
                                      <option
                                        v-for="category in this.subSelect"
                                        :key="category.category_id"
                                        :value="category.title"
                                      >
                                        {{ category.title }}
                                      </option>
                                    </select>
                                  </div>
                                </Transition>
                              </div>
                              <div class="col-lg-6">
                                <Transition name="scale" mode="out-in">
                                  <div
                                    class="form-group"
                                    v-if="this.subSubSelect.length > 0"
                                  >
                                    <label>تصنيف فرعى</label>
                                    <select
                                      class="form-select form-control mt-2"
                                      aria-label="Default select "
                                      @change="onSelectSubSubCategory($event)"
                                    >
                                      <option selected disabled value="">
                                        اختار التصنيف
                                      </option>
                                      <option
                                        v-for="category in this.subSubSelect"
                                        :key="category.category_id"
                                        :value="category.title"
                                      >
                                        {{ category.title }}
                                      </option>
                                    </select>
                                  </div>
                                </Transition>
                              </div>
                              <div class="col-lg-6">
                                <Transition name="scale" mode="out-in">
                                  <div
                                    class="form-group"
                                    v-if="this.subSubSubSelect.length > 0"
                                  >
                                    <label>تصنيف فرعى</label>
                                    <select
                                      class="form-select form-control mt-2"
                                      aria-label="Default select "
                                      @change="
                                        onSelectSubSubSubCategory($event)
                                      "
                                    >
                                      <option selected disabled value="">
                                        اختار التصنيف
                                      </option>
                                      <option
                                        v-for="category in this.subSubSubSelect"
                                        :key="category.category_id"
                                        :value="category.title"
                                      >
                                        {{ category.title }}
                                      </option>
                                    </select>
                                  </div>
                                </Transition>
                              </div>
                            </div>
                          </div>
                          <div
                            v-show="this.categories.length == 0"
                            class="categories__select__noData pt-3"
                          >
                            <p>اختار التصنيف:</p>
                            <h6 class="text-center pb-3">
                              لا يوجد تصنيفات حتى الآن
                            </h6>
                          </div>
                        </div>
                        <!-- Add Categories Select -->
                      </div>
                      <div class="card-footer">
                        <button
                          class="btn add"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                          type="submit"
                        >
                          أضافة
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from "vuex";

// Swal
import Swal from "sweetalert2";
// Firebase Upload Component
import FirebaseUploadingFileVue from "@/components/FirebaseUploadingFile.vue";
// Toast to Show Message
import { useToast, TYPE } from "vue-toastification";
const toast = useToast();
// Upload Image Drag and Drop
import UploadImages from "vue-upload-drop-images";
// Delete
import { deleteFileFromUrl } from "@/firebase/firebase_storage";

export default {
  data() {
    return {
      // today
      today: new Date().toISOString().substr(0, 10),

      // All Categories
      categories: [],
      // Get Categories has Main
      Maincategories: [],
      // Loop for Categories
      selectedCategory: null,
      selectedSubCategory: null,
      selectedSubSubCategory: null,
      // Save Result loop Categories
      subSelect: [],
      subSubSelect: [],
      subSubSubSelect: [],
      // Loading
      isLoading: false,
      file: null,
      icon: null,
      file_image: null,
      lessonImage: null,
      uploadProgress: 0,
      lesson: {
        title: "",
        status: 1,
        price: "",
        categories: [], // ids
        fullCategoriesInfo: [],
        icon: null,
        contents: [],
      },
      selectedFileLesson: {
        type: 1, // 1 => file -- // 2 => video -- // 3 => exams
        url: "",
        title: "",
        image_url: null,
        size: "", // file size
        file_type: "", // 1 => image -- // 2 => pdf
        file_id: "", // file name
        created_date: new Date(), // Timestamp
      },
      // Upload PDF or IMAGE
      UpdateType: "image/jpeg",
      thumb: null,
    };
  },
  components: {
    UploadImages,
  },
  methods: {
    ...mapActions("lessonsModule", [
      "clearState",

      // Add
      "addLesson",
      "addFile",
      "saveLessonData",

      // Get By ID
      "getFileByID",
      "getVideoByID",

      // Upadted
      "updateFileById",

      // Delete
      "deleteFileByid",
      "deleteVideoByid",
      "deleteExamByid",
    ]),

    deleteLesson() {
      this.clearState();
      this.$router.push("/admin/lessons");
    },

    saveLesson() {
      this.saveLessonData(this.lesson);
    },

    async getSelectedFile(id) {
      this.selectedFileLesson = await this.getFileByID(id);
      console.log(this.selectedFileLesson);
    },

    updateSelectedFile(event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");

      if (this.file !== null) {
        let fileExtension = this.file.name.split(".").pop();

        if (fileExtension == "pdf") {
          this.selectedFileLesson.file_type = 2;
          this.UpdateType = "application/pdf";
        } else {
          this.selectedFileLesson.file_type = 1;
          this.UpdateType = "image/jpeg";
        }
        const content = {
          // Your component or JSX template
          component: FirebaseUploadingFileVue,
          // Props are just regular props, but these won't be reactive
          props: {
            title: "يتم رفع الملف الان",
            file: this.file,
            collection: "IMAGEs",
            // pdf: this.file,
            contentType: this.UpdateType,
            onFinished: (url) => {
              this.selectedFileLesson.url = url ?? "";
              toast.dismiss(toastId);
              if (this.file_image) {
                const content = {
                  component: FirebaseUploadingFileVue,
                  props: {
                    title: "يتم رفع صورة الملف الان",
                    file: this.file_image,
                    collection: "Images",
                    onFinished: (url) => {
                      this.selectedFileLesson.image_url = url ?? "";
                      toast.dismiss(toastId);
                      this.updateFileById(this.selectedFileLesson);
                      closeButton.click();
                      this.clearAndShowSuccess("تم تعديل الملف بنجاح");
                    },
                  },
                };
                const toastId = toast(content, {
                  icon: false,
                  hideProgressBar: true,
                  closeButton: false,
                  type: TYPE.INFO,
                  timeout: false,
                  toastClassName: "my-custom-toast-class",
                });
              } else {
                this.updateFileById(this.selectedFileLesson);
                closeButton.click();
                this.clearAndShowSuccess("تم تعديل الملف بنجاح");
              }
            },
          },
        };

        const toastId = toast(content, {
          icon: false,
          hideProgressBar: true,
          closeButton: false,
          type: TYPE.INFO,
          timeout: false,
          toastClassName: "my-custom-toast-class",
        });
      } else {
        this.updateFileById(this.selectedFileLesson);
        closeButton.click();
        this.clearAndShowSuccess("تم تعديل الملف بنجاح");
      }
    },

    deleteSeletedFile(file) {
      Swal.fire({
        text: "هل أنت متأكد من حذف هذا الملف؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            text: "تم حذف الملف بنجاح",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          this.deleteFileByid(file.id);
          deleteFileFromUrl(file.image_url);
          deleteFileFromUrl(file.url);
        }
      });
    },

    deleteSeletedVideo(video) {
      console.log(video);
      Swal.fire({
        text: "هل أنت متأكد من حذف هذا الفيديو؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            text: "تم حذف الفيديو بنجاح",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          this.deleteVideoByid(video.id);
          deleteFileFromUrl(video.thumbnail_url);
        }
      });
    },

    deleteSeletedExam(exam) {
      Swal.fire({
        text: "هل أنت متأكد من حذف هذا الاختبار؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            text: "تم حذف الاختبار بنجاح",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          this.deleteExamByid(exam.id);
        }
      });
    },

    //------------------------------------//
    // Adding Files in Firebase Storge
    // Add File
    async addNewFile(event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");

      let fileExtension = this.file.name.split(".").pop();

      if (fileExtension == "pdf") {
        this.selectedFileLesson.file_type = 2;
        this.UpdateType = "application/pdf";
      } else {
        this.selectedFileLesson.file_type = 1;
        this.UpdateType = "image/jpeg";
      }

      if (this.file !== null) {
        const content = {
          // Your component or JSX template
          component: FirebaseUploadingFileVue,
          // Props are just regular props, but these won't be reactive
          props: {
            title: "يتم رفع الملف الان",
            file: this.file,
            collection: "IMAGEs",
            // pdf: this.file,
            contentType: this.UpdateType,
            onFinished: (url) => {
              this.selectedFileLesson.url = url ?? "";
              toast.dismiss(toastId);
              if (this.file_image) {
                const content = {
                  component: FirebaseUploadingFileVue,
                  props: {
                    title: "يتم رفع صورة الملف الان",
                    file: this.file_image,
                    collection: "Images",
                    onFinished: (url) => {
                      this.selectedFileLesson.image_url = url ?? "";
                      toast.dismiss(toastId);
                      this.addFile(this.selectedFileLesson);
                      closeButton.click();
                      this.clearAndShowSuccess("تم إضافة الملف بنجاح");
                    },
                  },
                };
                const toastId = toast(content, {
                  icon: false,
                  hideProgressBar: true,
                  closeButton: false,
                  type: TYPE.INFO,
                  timeout: false,
                  toastClassName: "my-custom-toast-class",
                });
              } else {
                this.addFile(this.selectedFileLesson);
                closeButton.click();
                this.clearAndShowSuccess("تم إضافة الملف بنجاح");
              }
            },
          },
        };

        const toastId = toast(content, {
          icon: false,
          hideProgressBar: true,
          closeButton: false,
          type: TYPE.INFO,
          timeout: false,
          toastClassName: "my-custom-toast-class",
        });
      }
    },
    // Add Lesson
    async addNewLesson() {
      if (this.icon !== null) {
        const content = {
          // Your component or JSX template
          component: FirebaseUploadingFileVue,

          // Props are just regular props, but these won't be reactive
          props: {
            title: "يتم رفع الصورة الان",
            file: this.icon,
            collection: "IMAGEs",
            onFinished: (url) => {
              console.log(url);
              this.lesson.icon = url ?? "";
              toast.dismiss(toastId);
              this.addLesson(this.lesson);
              this.clearAndShowSuccess("تم اضافة الدرس بنجاح");
              this.clearState();

              this.$router.push("/admin/lessons/");
            },
          },
        };

        const toastId = toast(content, {
          icon: false,
          hideProgressBar: true,
          closeButton: false,
          type: TYPE.INFO,
          timeout: false,
          toastClassName: "my-custom-toast-class",
        });
      } else {
        await this.addLesson(this.lesson);
        this.clearAndShowSuccess("تم اضافة الدرس بنجاح");
        this.clearState();
        this.$router.push("/admin/lessons/");
      }
    },
    //------------------------------------//
    filterItems(type) {
      switch (type) {
        case 1:
          this.files = this.lesson.contents;
          return "ملف";
        case 2:
          this.video = this.lesson.contents;
          return "فيديو";
        case 3:
          this.exam = this.lesson.contents;
          return "اختبار";
      }
    },
    // Handle Drag and Drop Component
    handleLessonImages(files) {
      this.icon = files[0];
    },
    handlefileImages(files) {
      this.file_image = files[0];
    },

    handleEditImages(files) {
      this.thumb = files[0];
      console.log(this.thumb);
    },
    //-----------------------------------------------------//
    // Get Categories
    ///// Get Main Category
    onSelectMainCategory($event) {
      let title = $event.target.value;
      this.selectedCategory = this.categories.filter(
        (item) => item.title === title
      )[0];
      // Reset Choose Sub Category
      this.subSelect = [];
      this.subSubSelect = [];
      this.subSubSubSelect = [];
      this.lesson.categories = [];
      this.lesson.fullCategoriesInfo = [];

      // Choose Sub Category
      if (this.selectedCategory.sub_categories.length > 0) {
        this.subSelect.push(...this.selectedCategory.sub_categories);
      }
      this.lesson.categories.push(this.selectedCategory.category_id);
      this.lesson.fullCategoriesInfo.push(this.selectedCategory);
      document.getElementById("subCategory").value = 0;
    },
    ///// Get Sub Category
    onSelectSubCategory($event) {
      let title = $event.target.value;
      this.selectedSubCategory = this.subSelect.filter(
        (item) => item.title === title
      )[0];
      this.subSubSelect = [];
      this.subSubSubSelect = [];

      this.lesson.categories.splice(1, 1);
      this.lesson.fullCategoriesInfo.splice(1, 1);
      if (this.selectedSubCategory.sub_categories.length > 0) {
        this.subSubSelect.push(...this.selectedSubCategory.sub_categories);
      }
      this.lesson.categories.push(this.selectedSubCategory.category_id);
      this.lesson.fullCategoriesInfo.push(this.selectedSubCategory);
    },
    ///// Get Sub Sub Category
    onSelectSubSubCategory($event) {
      let title = $event.target.value;
      this.selectedSubSubCategory = this.subSubSelect.filter(
        (item) => item.title === title
      )[0];
      this.subSubSubSelect = [];
      if (this.selectedSubSubCategory.sub_categories.length > 0) {
        this.subSubSubSelect.push(
          ...this.selectedSubSubCategory.sub_categories
        );
      }
      this.lesson.categories.splice(2, 1);
      this.lesson.fullCategoriesInfo.splice(2, 1);
      this.lesson.categories.push(this.selectedSubSubCategory.category_id);
      this.lesson.fullCategoriesInfo.push(this.selectedSubSubCategory);
    },

    ///// Get Sub Sub  Sub Category
    onSelectSubSubSubCategory($event) {
      let title = $event.target.value;
      this.selectedSubSubSubCategory = this.subSubSubSelect.filter(
        (item) => item.title === title
      )[0];
      this.lesson.categories.splice(3, 1);
      this.lesson.fullCategoriesInfo.splice(3, 1);
      this.lesson.categories.push(this.selectedSubSubSubCategory.category_id);
      this.lesson.fullCategoriesInfo.push(this.selectedSubSubSubCategory);
    },
    //-----------------------------------------------------//

    //---------------------//
    // clear Data when close modal
    clearData() {
      this.file = null;
      this.file_image = null;
      let clearButton = document.querySelector(".clearButton");
      clearButton.click();
      document.getElementById("mainCategory").value = 0;

      document.getElementById("chooseFiles").value = "";
      document
        .getElementsByClassName("dragDrop")[0]
        .classList.remove("drop_zone");
      this.subSelect = [];
      this.subSubSelect = [];
      this.subSubSubSelect = [];

      this.selectedCategory = [];
      this.selectedSubCategory = [];
      this.selectedSubSubCategory = [];

      this.selectedFileLesson = {
        type: 1, // 1 => file -- // 2 => video -- // 3 => exams
        url: "",
        title: "",
        size: "", // file size
        file_type: "", // 1 => image -- // 2 => pdf
        file_id: "", // file name
        created_date: new Date(), // Timestamp
      };
    },
    // On Upload Image
    seccussAdd(message) {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "success",
        title: message,
      });
    },
    // All Two functions
    clearAndShowSuccess(message) {
      this.seccussAdd(message);
      this.clearData();
    },

    //-----------------------------------------------------//
    ///// Custom Input File
    // Drop Over Elemet area
    onDropOver($event) {
      let el = $event.currentTarget;
      el.classList.add("drop_zone");
    },
    // Drop Leave Elemet area
    onDropLeave($event) {
      let el = $event.currentTarget;
      el.classList.remove("drop_zone");
    },
    // When Select File
    onFileSelect(e) {
      let file = e.target.files[0] || e.dataTransfer;
      this.file = file;
      this.selectedFileLesson.file_id = file.name;
      this.selectedFileLesson.size = file.size;

      //  Change file_type Number to Know File Type
      if (file.type.includes("image")) {
        this.selectedFileLesson.file_type = 1;
      } else if (file.type.includes("pdf")) {
        this.selectedFileLesson.file_type = 2;
      }
      //  Change Type Number to Know File Type
      if (file.type.includes("image") || file.type.includes("pdf")) {
        this.selectedFileLesson.type = 1;
        if (file.type.includes("image")) {
          this.selectedFileLesson.file_type = 1;
        } else if (file.type.includes("pdf")) {
          this.selectedFileLesson.file_type = 2;
        }
      } else if (file.type.includes("video")) {
        this.selectedFileLesson.type = 2;
      } else {
        this.selectedFileLesson.type = 3;
      }
    },
    //-----------------------------------------------------//
  },

  async created() {
    console.log(this.getContents);
    // get Main Categories
    this.Maincategories = this.getCategories.filter(
      (item) => item.main_category === true
    );
  },

  computed: {
    ...mapGetters("categoriesModule", ["getCategories"]),
    ...mapGetters("lessonsModule", ["getContents", "getLesson"]),
  },
  mounted() {
    this.categories = this.getCategories;
    this.lesson = this.getLesson;
    this.lesson.contents = this.getContents;
    document.getElementById("mainCategory").value = 0;
  },
  watch: {
    getCategories() {
      this.categories = this.getCategories;
    },
    getLesson() {
      this.lesson = this.getLesson;
    },
    getContents() {
      this.lesson.contents = this.getContents;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>